import authService from "@services/auth";
import router from "@router";
// import enums from "@services/auth"
const user = JSON.parse(localStorage.getItem("@USER"));
// const perfil = JSON.parse(localStorage.getItem("@PERFIL"));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: {} };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, { email, password }) {
      commit("loginRequest", { email });
      authService.login(email, password).then(
        user => {
          commit("loginSuccess", user);
          router.push("/");
        },
        error => {
          commit("loginFailure", error);
        }
      );
    },
    logout({ commit }) {
      authService.logout();
      commit("logout");
    },
    token({ commit }, { token, expires }) {
      var user = authService.token(token, expires);
      commit("loginSuccess", user);
      router.push("/");
    }
  },
  mutations: {
    loginRequest(state, user) {
      state.status = { loggingIn: true };
      state.user = user;
    },
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;
    },
    loginFailure(state) {
      state.status = {};
      state.user = {};
    },
    logout(state) {
      state.status = {};
      state.user = {};
    }
  }
};
